import Financial from './index'
import currentTreasure from './components/CurrentTreasure'
import staking from './components//Staking'

export default {
  path: '/home/financial',
  component: Financial,
  children: [
    { path: '/home/financial/currentTreasure', component: currentTreasure },
    { path: '/home/financial/staking', component: staking },
  ],
}
